import React from 'react';
import { Link } from 'react-router-dom';
import { Building2 } from 'lucide-react';

type CitizenAuthVariant = 'page' | 'centered';

export interface CitizenAuthLayoutProps {
  children: React.ReactNode;
  variant?: CitizenAuthVariant;
  headerAction?: React.ReactNode;
  brandHref?: string;
  brandLabel?: string;
  showHeader?: boolean;
  showBrandIcon?: boolean;
  contentClassName?: string;
}

const CitizenAuthLayout: React.FC<CitizenAuthLayoutProps> = ({
  children,
  variant = 'page',
  headerAction,
  brandHref = '/',
  brandLabel = 'Capitol Commons',
  showHeader = true,
  showBrandIcon = true,
  contentClassName = 'max-w-md w-full space-y-8',
}) => {
  if (variant === 'centered') {
    return (
      <div className="min-h-screen bg-background dark:bg-background-dark-primary flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        {children}
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background dark:bg-background-dark-primary flex flex-col">
      {showHeader && (
        <header className="border-b border-border-light dark:border-border-dark">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center py-6">
              <Link to={brandHref} className="flex items-center space-x-3">
                {showBrandIcon && (
                  <div className="w-8 h-8 bg-primary-700 rounded-md flex items-center justify-center">
                    <Building2 className="w-5 h-5 text-white" />
                  </div>
                )}
                <h1 className="text-xl font-bold text-text-primary dark:text-text-dark-primary">
                  {brandLabel}
                </h1>
              </Link>
              <div className="flex items-center space-x-4">{headerAction}</div>
            </div>
          </div>
        </header>
      )}

      <div className="flex-1 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className={contentClassName}>{children}</div>
      </div>
    </div>
  );
};

export default CitizenAuthLayout;
